export default __webpack_public_path__ + "static/MediaContentOneM-24ea9db648c23ebaa9bea0833cdc73ae.webp";